import { render, staticRenderFns } from "./TableEditLink.vue?vue&type=template&id=b5ead04e&scoped=true&"
import script from "./TableEditLink.vue?vue&type=script&lang=js&"
export * from "./TableEditLink.vue?vue&type=script&lang=js&"
import style0 from "./TableEditLink.vue?vue&type=style&index=0&id=b5ead04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ead04e",
  null
  
)

component.options.__file = "TableEditLink.vue"
export default component.exports